import React, { useEffect, useState } from "react";
import api from '../../services/api';
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import { DynamicTextareaOnChange } from "../../components/DynamicTextarea";
import { StyledForm } from "../../styled-components/StyledForm.style";

export const ModalVisibilidadeMensagens = ({
    processo,
    tarefa,
    isTarefa,
    isOpen,
    setIsOpen,
    aoSalvar
}) => {
    const [isLoading, setisLoading] = useState(false);
    const [observacao, setObservacao] = useState("");
    const [loadMensagens, setLoadMensagens] = useState(null);

    const COR_SINALIZADORES = {
        0: "",
        1: "#10B981",
        2: "#f7cc4d",
        3: "#f16262",
        4: "#aa0505",
    };

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        },
    };

    const onAfterOpen = () => { };
    const closeModal = () => { 
        setisLoading(false);
        setObservacao("");
        setIsOpen(false); 
    }

    const getLoadMensagens = async (idProcesso) => {
        setisLoading(true);

        let list = null;
        var tipoMensagem = isTarefa ? `tarefa/${idProcesso}/${tarefa.idTarefa}` : `processo/${idProcesso}`;
        try {
            const headers = { 'Content-Type': 'application/json' };
            const response = await api.get(`Visibilidade/tarefa/load/mensagens/${tipoMensagem}`, {
                params: {
                    idTipoServico: processo.idTipoServico
                },
                headers: headers
            });
            list = response.data.data;
            setLoadMensagens(list);
        } catch (err) {
            console.error(err);
        } finally {
            setisLoading(false);
            return list;
        }
    }

    const onClickAction = (idTarefa, tipoAcao) => {
        Swal.fire({
            html: `Deseja Realizar essa Ação?`,
            icon: "info",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            setisLoading(true);
            if (result.isConfirmed) {
                Swal.showLoading();
                try {
                    const headers = {
                        'Content-Type': 'application/json'
                    };

                    const dados = {
                        idTipoAcao: tipoAcao,
                        observacao: observacao,
                    };
                    await api.post(`Visibilidade/tarefa/executa/mensagem/${idTarefa}`, dados, { headers });
                    setisLoading(false);

                    Swal.fire({
                        title: "Sucesso",
                        text: "Mensagem Adicionada com Sucesso!",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    }).then(async (result) => {;
                        setObservacao("");

                        setisLoading(false);
                        setIsOpen(false);
                        closeModal();

                        if (aoSalvar) {
                            aoSalvar(processo.idProcesso, processo.idTipoServico);
                        }
                    })

                } catch (err) {setisLoading(false);}
            } else {
                setisLoading(false);
            }
        });
    };

    useEffect(() => {
        if(isOpen) {
            getLoadMensagens(processo.idProcesso);
        }
    }, [isOpen])

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Iniciar"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="28" height="28" className="me-2">
                                        <path fill={'#999'} d="M384 144c0 97.2-86 176-192 176-26.7 0-52.1-5-75.2-14L35.2 349.2c-9.3 4.9-20.7 3.2-28.2-4.2s-9.2-18.9-4.2-28.2l35.6-67.2C14.3 220.2 0 183.6 0 144 0 46.8 86-32 192-32S384 46.8 384 144zm0 368c-94.1 0-172.4-62.1-188.8-144 120-1.5 224.3-86.9 235.8-202.7 83.3 19.2 145 88.3 145 170.7 0 39.6-14.3 76.2-38.4 105.6l35.6 67.2c4.9 9.3 3.2 20.7-4.2 28.2s-18.9 9.2-28.2 4.2L459.2 498c-23.1 9-48.5 14-75.2 14z"/></svg>
                                    Mensagens {isTarefa ? "da Tarefa" : "do Processo"}</p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}><button className="default-button-red-small px-2">X</button></p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                { isLoading ? 
                (
                <div className="text-center">
                    <div className="text-items-center">
                        <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                        <div className="mt-2">
                            <strong style={{ color: "#EE4B21" }}>Aguarde enquanto validamos as informações</strong>
                        </div>
                    </div>
                </div>
                ) : (
                    <>
                    <div className="row mb-2" style={{ fontSize: "14px" }}>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Processo</span><br/>{ processo?.processoSigla || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Líder</span><br/>{ processo?.liderProcesso || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Cliente</span><br/>{ processo?.cliente || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Segurado</span><br/>{ processo?.segurado || "-" }</div>
                    </div>
                    <div className="row" style={{ fontSize: "14px" }}>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Disciplina</span><br/>{ processo?.disciplina }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Data Abertura</span><br/>{ new Date(processo?.dataAbertura).toLocaleDateString('pt-BR') }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Status</span><br/>{ processo?.statusProcesso }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Sinalização</span><br/><strong><span style={ {color: COR_SINALIZADORES[processo?.tipoSinalizacao?.idTipoSinalizacao || 0]}}>{processo?.tipoSinalizacao?.tipoSinalizacaoDescricao || '-'}</span></strong></div>
                    </div>
                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>
                    
                    { loadMensagens?.map((item) => (
                        <React.Fragment key={item.idProcesso}>
                            <div className="card mb-2">
                                <div className="card-body pt-1 pb-0 px-2 row mb-2" style={{ fontSize: "14px" }}>
                                    <div className="position-absolute top-0 end-0 badge rounded opacity-50 bg-secondary " style={{ color: "#fff", fontSize: "12px", fontWeight: "normal", width: "200px" }}><i className="fa fa-user"></i> {item.nomeUsuario} <i className="fa fa-calendar ms-2"></i> { new Date(item.dataCriacao).toLocaleDateString('pt-BR') }</div>
                                    <div className=""><strong>{item.nomeEtapa}</strong></div>
                                    <div className="">{item.mensagem}</div>
                                </div>
                            </div>
                        </React.Fragment>
                    )) }

                    { loadMensagens?.length === 0 && (
                        <div className="text-center mt-4 mb-4">
                            <span style={{ color: "#999" }}>Nenhuma mensagem encontrada para {isTarefa ? "esta tarefa" : "este processo"}.</span>
                        </div>
                    ) }

                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                    {isTarefa && (tarefa?.status == 1 || tarefa?.status == 2 || tarefa?.status == 3) && (
                    <>
                        <div className="row align-items-center justify-content-center">
                            <div className="col text-center">
                                <DynamicTextareaOnChange 
                                    placeholder={"Mensagem adicional..."} 
                                    label={"Mensagem"} 
                                    name={"observacao"}
                                    valuetext={observacao}
                                    onChange={(e) => setObservacao(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>
                        <Flex>
                            <Flex.Item>
                                <div className="row align-items-center justify-content-center">
                                    <div className="col text-center">
                                        <input 
                                            className='default-button-red' 
                                            value={'Deixar Mensagem'} 
                                            type="button" 
                                            onClick={onClickAction.bind(this, tarefa?.idTarefa, processo?.idTipoServico)}/>
                                    </div>
                                </div>
                            </Flex.Item>
                        </Flex>
                    </>
                    ) }
                    </>
                )}
            </StyledForm>
        </Modal>
    );
};